import React, { ReactElement, FC, CSSProperties, Fragment } from 'react'
import { useTranslation } from 'react-i18next'
import { Divider, Typography } from 'antd'
import { PaperClipOutlined } from '@ant-design/icons'
import { s } from './style'
import { AttachmentsProposalFragment } from './Attachments.generated-types'

const { Link, Text } = Typography

interface AttachmentProps {
  proposal: AttachmentsProposalFragment
  strong?: boolean
  style?: CSSProperties
}

export const Attachments: FC<AttachmentProps> = ({
  proposal: { documents },
  strong = false,
  style,
}): ReactElement => {
  const { t } = useTranslation()

  const length = documents.length

  if (length === 0) return null

  return (
    <>
      {documents.map(({ filename, URL }, index) => (
        <Fragment key={URL}>
          <div style={{ ...s.spaceBetweenRow, ...style }}>
            <div style={s.row}>
              <PaperClipOutlined style={s.paperClip} />
              <Text strong={strong}>{filename}</Text>
            </div>
            <Link
              href={`https://${URL}`}
              target='_blank'
              strong={strong}
              style={{ fontSize: strong ? 18 : 16 }}>
              {t('eventHub.confirmed.download', 'Download')}
            </Link>
          </div>
          {index < length && <Divider style={s.divider} />}
        </Fragment>
      ))}
    </>
  )
}
